import { StateInterface } from "./state";
import { LicenseModel } from "../models";

export default {
  currentLicense(state: StateInterface): LicenseModel {
    return state.current;
  }
};
